import { render } from "./submittedSummary.vue?vue&type=template&id=1f5f6f39"
import script from "./submittedSummary.vue?vue&type=script&lang=js"
export * from "./submittedSummary.vue?vue&type=script&lang=js"

import "./submittedSummary.vue?vue&type=style&index=0&id=1f5f6f39&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__